import React, { useState } from "react";
import ErrorMessage from "../../Components/ErrorMessage";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";

const AboutYoutStep = ({
    handleStep,
    soundClick,
    error,
    loadingSteps,
    selectedOptions,
    setSelectedOptions
}) => {
    const { t } = useLanguage()
    const MAX_SELECTIONS = 3;

    const handleSelect = (value) => {
        soundClick();

        setSelectedOptions((prev) => {
            const isSelected = prev.includes(value);
            if (isSelected) {
                return prev.filter((item) => item !== value);
            }

            if (prev.length >= MAX_SELECTIONS) {
                return [...prev.slice(1), value];
            }
            return [...prev, value];
        });
    };

    return (
        <div className="steps_main_container">
            <div className="welcome_step_cont">
                <div className="welcome_step_cont_inner">
                    <p className="step_title fade-in">{t.onboarding.about_you.title}</p>
                    <p className="step_description fade-in">{t.onboarding.about_you.subtitle}</p>
                    <div className="about_you_cont">
                        {t.onboarding.about_you.about_you_options.map((option) => (
                            <div
                                key={option.value}
                                className={`about_you_choise fade-in ${selectedOptions.includes(option.value) && "about_you_choise_selected"
                                    }`}
                                onClick={() => handleSelect(option.value)}
                            >
                                {option.label}
                            </div>
                        ))}
                    </div>
                    <p className="about_you_count">{selectedOptions.length}/{MAX_SELECTIONS}</p>
                </div>
            </div>

            <div className="steps_btn_cont">
                <button
                    className="steps_btn"
                    onClick={() => handleStep("back", "info")}
                >
                    <i className="fa-solid fa-chevron-left"></i> {t.onboarding.back}
                </button>
                <div>
                    <ErrorMessage err={error} />
                </div>
                <button className="steps_btn fade-in" onClick={() => handleStep("continue", "people")}>
                    {loadingSteps ? (
                        <Spinner loading={true} />
                    ) : (
                        <>{t.onboarding.continue} <i className="fa-solid fa-chevron-right"></i></>
                    )}
                </button>
            </div>
        </div>
    );
};

export default AboutYoutStep;